'use client';

import { useEffect, useState } from 'react';

import type { ImageProps, StaticImageData } from 'next/image';
import Image from 'next/image';

type ImageWithFallBackProps = {
  fallbackSrc?: StaticImageData;
} & Omit<ImageProps, 'src'> & { src: StaticImageData };

export function ImageWithFallBack(props: ImageWithFallBackProps) {
  const { src: initialSrc, alt, fallbackSrc, ...rest } = props;
  const [src, setSrc] = useState(initialSrc);

  useEffect(() => {
    setSrc(initialSrc);
  }, [initialSrc]);

  return (
    <Image
      {...rest}
      src={src}
      alt={alt}
      onError={() => {
        if (fallbackSrc) setSrc(fallbackSrc);
      }}
    />
  );
}
